import { useEffect, useState } from "react";

const defaultGetKey = (row: { serial_number: string }) => row.serial_number;

export function useMeterSelection<T>(
	rows: T[],
	deps: unknown[],
	getKey: (row: T) => string = defaultGetKey as (row: T) => string,
) {
	const [selected, setSelected] = useState<Set<string>>(new Set());

	useEffect(() => {
		setSelected(new Set());
		// biome-ignore lint/correctness/useExhaustiveDependencies: deps array is intentionally passed by the caller
	}, deps); // eslint-disable-line react-hooks/exhaustive-deps

	const isAllSelected =
		rows.length > 0 && rows.every((r) => selected.has(getKey(r)));
	const isIndeterminate =
		!isAllSelected && rows.some((r) => selected.has(getKey(r)));

	function toggleRow(key: string) {
		setSelected((prev) => {
			const next = new Set(prev);
			if (next.has(key)) next.delete(key);
			else next.add(key);
			return next;
		});
	}

	function toggleAll() {
		if (isAllSelected) {
			setSelected(new Set());
		} else {
			setSelected(new Set(rows.map(getKey)));
		}
	}

	function clearSelection() {
		setSelected(new Set());
	}

	return {
		selectedSerials: Array.from(selected),
		toggleRow,
		toggleAll,
		isAllSelected,
		isIndeterminate,
		clearSelection,
	};
}
